module.exports = __webpack_public_path__ + "img/pc.ffa4f20a.png";